import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import { ISupplierContactHistoryResponse } from './use-get-supplier-contact-history-api';

type TData = ISupplierContactHistoryResponse;
type TError = AxiosError;
type TQueryKey = [
  string,
  {
    supplierId: number;
    page: number;
    limit: number;
    fromDate?: string;
    toDate?: string;
  }
];

type Options = Omit<UseQueryOptions<TData, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetSupplierContactHistoryModalApi(
  supplierId: number,
  page: number,
  limit: number,
  options?: Options & {
    fromDate?: string;
    toDate?: string;
  }
): ReturnType {
  const isLoggedIn = useIsLoggedIn();
  const { fromDate, toDate, ...queryOptions } = options || {};

  const endpoint = `ums/v1/crm/management/suppliers/contact-quotas/history/supplier/${supplierId}`;

  const queryKey: TQueryKey = [
    endpoint,
    {
      supplierId,
      page,
      limit,
      fromDate,
      toDate,
    },
  ];

  const queryFn = async () => {
    const params: any = {
      page: page || 1,
      limit: limit || 20,
    };

    if (fromDate) {
      params.fromDate = fromDate;
    }

    if (toDate) {
      params.toDate = toDate;
    }

    const { data } = await http.get(endpoint, { params });
    return data;
  };

  return useQueryWrapper(queryKey, queryFn, {
    enabled: isLoggedIn && !!supplierId && page > 0 && limit > 0,
    ...queryOptions,
  });
}
